export default {
  'BadgeCard.Info.LeftAssignments.Achieved': () => { },
  'BadgeCard.Info.LeftAssignments.OnTrack': () => { }
}